export default __webpack_public_path__ + "static/media/recibo.957092b9.png";